import { gql } from "graphql-request";

export const ADMIN_ARTICLES = gql`
  query AdminArticles($input: AdminArticlesInputDto!) {
    adminArticles(input: $input) {
      items {
        _id
        type
        title {
          ko
          en
        }
        excerpt {
          ko
          en
        }
        thumbnail {
          url {
            ko
            en
          }
          alt {
            ko
            en
          }
        }
        authorInfo {
          name {
            ko
            en
          }
          profileImageURL {
            ko
            en
          }
          biography {
            ko
            en
          }
          socialAccounts {
            platformName
            link {
              ko
              en
            }
          }
        }
        publishedAt
        createdAt
        updatedAt
      }
      meta {
        totalCount
        totalPages
        currentPage
        limit
        hasNextPage
        hasPrevPage
      }
    }
  }
`;

export const ADMIN_ARTICLE_BY_ID = gql`
  query AdminArticleById($articleId: String!) {
    adminArticleById(articleId: $articleId) {
      ... on AdminBlogArticleDetailDto {
        _id
        type
        title {
          ko
          en
        }
        excerpt {
          ko
          en
        }
        url {
          ko
          en
        }
        thumbnail {
          url {
            ko
            en
          }
          alt {
            ko
            en
          }
        }
        authorInfo {
          name {
            ko
            en
          }
          profileImageURL {
            ko
            en
          }
          biography {
            ko
            en
          }
          socialAccounts {
            platformName
            link {
              ko
              en
            }
          }
        }
        publishedAt
        createdAt
        updatedAt
      }
      ... on AdminPremiumArticleDetailDto {
        _id
        type
        title {
          ko
          en
        }
        excerpt {
          ko
          en
        }
        content {
          ko
          en
        }
        freeContent {
          ko
          en
        }
        sourceFileId
        sourceFileUpdatedAt
        thumbnail {
          url {
            ko
            en
          }
          alt {
            ko
            en
          }
        }
        authorInfo {
          name {
            ko
            en
          }
          profileImageURL {
            ko
            en
          }
          biography {
            ko
            en
          }
          socialAccounts {
            platformName
            link {
              ko
              en
            }
          }
        }
        publishedAt
        createdAt
        updatedAt
      }
    }
  }
`;

export const ADMIN_AUTHOR_FILES = gql`
  query AdminAuthorFiles($input: AdminAuthorFilesInputDto!) {
    adminAuthorFiles(input: $input) {
      items {
        _id
        title
        updatedAt
        isPublished
        articleId
        hasUpdate
      }
      meta {
        totalCount
        totalPages
        currentPage
        limit
        hasNextPage
        hasPrevPage
      }
    }
  }
`;

export const ADMIN_AUTHOR_FILE_BY_ID = gql`
  query AdminAuthorFileById($fileId: String!) {
    adminAuthorFileById(fileId: $fileId) {
      _id
      title
      content
      updatedAt
    }
  }
`;
